<template>
    <tbody>
    <tr v-for="row of all_transactions">
        <td>{{ row.id}}</td>
        <td>{{ row.transaction_date}}</td>
        <td> <div @click="openUser(row.client.id)">{{ row.client.name    }}</div></td>
        <td><span :style="'color:'+transactionColors[row.type - 1]">{{ transactionTypes[row.type - 1] }}</span></td>
        <td>{{ getCurrency(row.client) }}{{ row.amount | formatNumber }}</td>
        <td>{{ getCurrency(row.client) }}{{ row.amount_used | formatNumber }}</td>
        <td>{{ getCurrency(row.client) }}{{ row.unused_amount | formatNumber }}</td>
        <td>
            <router-link
                    tag="button"
                    :to="row.type == 1 ? '/banking/edit/' + row.id : '/banking/edit-refund/' + row.id"
                    class="button is-primary mobile-first-btn">
                <span>Edit Transaction</span>
                <span class="icon is-small">
                          <i class="fas fa-edit"></i>
                        </span>
            </router-link>

            <a class="button is-danger" @click="transactionDeleteModal(row.id, row.type)"> <span>Delete Transaction</span>
                <span class="icon is-small">
                          <i class="fas fa-trash"></i>
                        </span></a>
        </td>
    </tr>
    </tbody>

</template>

<script>
    import apiBankingTransactions from './../../api/apiBankingTransactions'
    export default {
        components: {},
        data() {
            return {
                transactionTypes: ['Money In', 'Money Out', 'Payment'],
                transactionColors: ['green', 'red', 'blue'],
                rows: [
                    ['1', '2020-06-06', 'Gabriel', 'REF#123', '<span class="has-text-danger">MONEY OUT</span>', '$1450'],
                    ['1', '2020-05-01', 'Juan', 'REF#123', '<span class="has-text-success">MONEY IN</span>', '$1270'],
                    ['1', '2020-04-04', 'Jorge', 'REF#123', '<span class="has-text-primary">PAYMENT</span>', '$370'],
                ]
            }
        },
        computed: {
            all_transactions(){
                return this.$store.getters.getAllTransactions
            }
        },
        methods: {
            transactionDeleteModal(transactionId, type){
                this.$store.commit('setTransactionDeleteModalStatus', true)
                this.$store.commit('setTransactionDeleteId', transactionId)
                this.$store.commit('setBTransactionType', type)
            },
            openUser(userId){
                this.$store.dispatch('setActiveUserTab', 'garage')
                this.$router.push({ path: '/users/edit/'+userId })
            },
            getCurrency(client){
                return client.price_plan.deposit_rate == 1 ? '¥' : '$'
            }
        },
        created() {
            this.$store.commit('setFilterTransactions', {client: '', search: '', dateFrom: '', dateTo: ''})
            this.$store.commit('setTransactionCurrentPage', this.$route.query.page ? this.$route.query.page : 1)
            this.$store.dispatch('getTransactionsAction');



        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Banking/TransactionTableRow.vue